import SparkMD5 from "spark-md5";

const CHUNK_SIZE = 5242880; //bytes. (5Mb)

export const fileMd5 = async (file: File): Promise<string> => {
  const chunks = Math.ceil(file.size / CHUNK_SIZE);
  let currentChunk = 0;
  const spark = new SparkMD5.ArrayBuffer();
  const fileReader = new FileReader();
  return new Promise((resolve, reject) => {
    fileReader.onload = function (e) {
      if (!e.target?.result) {
        return reject(e);
      }
      spark.append(e.target.result as ArrayBuffer);
      currentChunk++;
      if (currentChunk < chunks) {
        processNext();
      } else {
        resolve(spark.end());
      }
    };
    fileReader.onerror = function () {
      reject();
    };
    const processNext = () => {
      const start = currentChunk * CHUNK_SIZE;
      const end =
        start + CHUNK_SIZE >= file.size ? file.size : start + CHUNK_SIZE;
      fileReader.readAsArrayBuffer(file.slice(start, end));
    };
    processNext();
  });
};
